/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { useHistory } from 'react-router-dom';
import { formatBoolean } from 'components/helper/helper';
import { RequiredField } from 'screen/common/helper/checkFieldsMissingCondition';
import { ibSubjectHaveLanguageQuestion } from 'components/helper/appConfig';

interface ModalCheckTestFieldsProps {
  show?: boolean;
  onClose: () => void;
  data: any[];
  page: string;
}

export const ModalCheckTestFields = (props: ModalCheckTestFieldsProps) => {
  const { show, onClose, data, page } = props;
  const [fieldsFail, setFieldsFail] = useState<any[]>([]);
  const history = useHistory();

  const checkSatTestCondition =(data:any) => {
    let ret: RequiredField[]  = [];
    if (data?.number_of_past_sat_scores === null) {
      ret.push({
        key: 'satTest.number_of_past_sat_scores',
        name: 'Number of past SAT scores you wish to report*',
        page: '/application/sat-test?check=1'
      });
    }

    if (data?.taken_sat_essay_option === null) {
      ret.push({
        key: 'satTest.taken_sat_essay_option',
        name: 'Have you taken the SAT essay?*',
        page: '/application/sat-test?check=1'
      });
    }

    if (data?.csu_info?.sat_score && data?.csu_info?.sat_score.length > 0) {
      data.csu_info.sat_score.forEach((item: any, index: number) => {
          if (!item.test_date) {
            ret.push({
              key: `satTest.csu_info.sat_score[${index}].test_date`,
              name: `Test Date (${index + 1})`,
              page: '/application/sat-test?check=1',
            });
          }
          if (!item.total_score) {
            ret.push({
                key: `satTest.csu_info.sat_score[${index}].total_score`,
                name: `Total Score (${index + 1})`,
                page: '/application/sat-test?check=1'
            });
          }
          if (!item.reading_writing_score) {
            ret.push({
              key: `satTest.csu_info.sat_score[${index}].reading_writing_score`,
              name: `Evidenced Based Reading/Writing Score (${index + 1})`,
              page: '/application/sat-test?check=1',
            });
          }
          if (!item.math_score) {
            ret.push({
              key: `satTest.csu_info.sat_score[${index}].math_score`,
              name: `Math Score (${index + 1})`,
              page: '/application/sat-test?check=1'
            });
          }
      });
    }

    if (data?.highest_evidence_reading_writing_score === null) {
      ret.push({
        key: 'satTest.highest_evidence_reading_writing_score',
        name: 'Highest Reading/Writing Score*',
        page: '/application/sat-test?check=1'
      });
    }
    if (data?.evidence_reading_writing_date === null) {
      ret.push({
        key: 'satTest.evidence_reading_writing_date',
        name: 'Highest Reading/Writing Score Date*',
        page: '/application/sat-test?check=1'
      });
    }

    if (data?.highest_math_score_based_evidence_reading_writing_score === null) {
      ret.push({
        key: 'satTest.highest_math_score_based_evidence_reading_writing_score',
        name: 'Highest Math Score*',
        page: '/application/sat-test?check=1'
      });
    }
    if (data?.math_reading_writing_date === null) {
      ret.push({
        key: 'satTest.math_reading_writing_date',
        name: 'Highest Math Score Date*',
        page: '/application/sat-test?check=1'
      });
    }

    if (formatBoolean(data?.taken_sat_essay_option)) {
      if (data?.combined_essay_score === null) {
        ret.push({
          key: 'satTest.combined_essay_score',
          name: 'Highest combined essay score',
          page: '/application/sat-test?check=1'
        });
      }
      if (data?.combined_essay_date === null) {
        ret.push({
          key: 'satTest.combined_essay_date',
          name: 'Combined essay date',
          page: '/application/sat-test?check=1',
        });
      }
    }

    if (data?.future_sat_tests_plan_to_take === null) {
      ret.push({
        key: 'satTest.future_sat_tests_plan_to_take',
        name: 'Number of future SAT sittings you expect*',
        page: '/application/sat-test?check=1'
      });
    }


    if ([1, '1', '2', '3', 2, 3].includes(data?.future_sat_tests_plan_to_take)) {
        if (!data?.future_testing_date_1?.test1) {
          ret.push({
            key: 'satTest.future_testing_date_1.test1',
            name: 'Future testing date 1',
            page: '/application/sat-test?check=1',
          });
        }
    }

    if (['2', '3', 2, 3].includes(data?.future_sat_tests_plan_to_take)) {
      if (!data?.future_testing_date_1?.test2) {
        ret.push({
          key: 'satTest.future_testing_date_1.test2',
          name: 'Future testing date 2',
          page: '/application/sat-test?check=1',
        });
      }
    }

    if (['3', 3].includes(data?.future_sat_tests_plan_to_take)) {
      if (!data?.future_testing_date_1?.test3) {
        ret.push({
          key: 'satTest.future_testing_date_1.test3',
          name: 'Future testing date 3',
          page: '/application/sat-test?check=1',
        });
      }
    }

    return ret;

  }

  const checkActTestCondition = (data:any) => {
    let ret: RequiredField[]  = [];
    //console.log('checkActTestCondition data: ', data);
    if (data?.number_of_act_score_report === null) {
      ret.push({
        key: 'actTest.number_of_act_score_report',
        name: 'Number of past ACT scores you wish to report*',
        page: '/application/act-test?check=1'
      }); 
    }
    if (data?.have_taken_act_plus_writing_test==null) {
      ret.push({
        key: 'actTest.have_taken_act_plus_writing_test',
        name: 'Have you taken the ACT Plus Writing test?*',
        page: '/application/act-test?check=1#have_taken_act_plus_writing_test'
      }); 
    }

    if (data?.csu_info?.act_score && data?.csu_info?.act_score.length > 0) {
      data.csu_info.act_score.forEach((item: any, index: number) => {
        //console.log('act item: ', item);
        if (!item?.test_date) {
          ret.push({
            key: `actTest.csu_info.act_score[${index}].test_date`,
            name: `Test Date (${index + 1})`,
            page: `/application/act-test?check=1&index=${index + 1}`,
          });
        }
        if (!item?.composite_score) {
          ret.push({
            key: `actTest.csu_info.act_score[${index}].composite_score`,
            name: `Composite score (${index + 1})`,
            page: `/application/act-test?check=1&index=${index + 1}`,
          });
        }
        if (!item?.english) {
          ret.push({
            key: `actTest.csu_info.act_score[${index}].english`,
            name: `English (${index + 1})`,
            page: `/application/act-test?check=1&index=${index + 1}`,
          });
        }
        if (!item?.mathematics) {
          ret.push({
            key: `actTest.csu_info.act_score[${index}].mathematics`,
            name: `Mathematics (${index + 1})`,
            page: `/application/act-test?check=1&index=${index + 1}`,
          });
        }
        if (!item?.reading) {
          ret.push({
            key: `actTest.csu_info.act_score[${index}].reading`,
            name: `Reading (${index + 1})`,
            page: `/application/act-test?check=1&index=${index + 1}`,
          });
        }
        if (!item?.science) {
          ret.push({
            key: `actTest.csu_info.act_score[${index}].science`,
            name: `Science (${index + 1})`,
            page: `/application/act-test?check=1&index=${index + 1}`,
          });
        }
        
        if (formatBoolean(data?.is_have_act_score_report) === true) {
          if (!item?.writing) {
            ret.push({
              key: `actTest.csu_info.act_score[${index}].writing`,
              name: 'Writing Score',
              page: `/application/act-test?check=1&index=${index + 1}`,
            });
          }
        }
      });
    }

    if (!data?.is_report_highest_act_science_score) {
      ret.push({
        key: 'actTest.is_report_highest_act_science_score',
        name: 'Would you like to report your highest ACT Science score? *',
        page: '/application/act-test?check=1#is_report_highest_act_science_score'
      });
    }

    if (!data?.is_report_highest_act_writing_score) {
      ret.push({
        key: 'actTest.is_report_highest_act_writing_score',
        name: 'Would you like to report your highest ACT Writing score? *',
        page: '/application/act-test?check=1#is_report_highest_act_writing_score'
      });
    }

    if (!data?.future_act_test_plan_to_take)  {
      ret.push({
        key: 'actTest.future_act_test_plan_to_take',
        name: 'Number of future ACT sittings you expect*',
        page: '/application/act-test?check=1#future_act_test_plan_to_take'
      });
    }

    if ([1, '1', '2', '3', 2, 3].includes(data?.future_act_test_plan_to_take)) {
      if (!data?.future_testing_date_1.test1) {
        ret.push({
          key: 'actTest.future_testing_date_1.test1',
          name: 'Future testing date 1',
          page: '/application/act-test?check=1#future_testing_date_1_test1',
        });
      }
    }

    if (['2', '3', 2, 3].includes(data?.future_act_test_plan_to_take)) {
      if (!data?.future_testing_date_1.test2) {
        ret.push({
          key: 'actTest.future_testing_date_1.test2',
          name: 'Future testing date 2',
          page: '/application/act-test?check=1#future_testing_date_1_test2',
        });
      }
    }

    if (['3', 3].includes(data?.future_act_test_plan_to_take)) {
      if (!data?.future_testing_date_1.test3) {
        ret.push({
          key: 'actTest.future_testing_date_1.test3',
          name: 'Future testing date 3',
          page: '/application/act-test?check=1#future_testing_date_1_test3',
        });
      }
    }
    return ret;
  }
  
  const checkIbSubjectCondition = (data:any) => {
    let ret: RequiredField[]  = [];
    if (data?.ib_test_array && data?.ib_test_array.length>0) {
      data?.ib_test_array.forEach((item: any, index: number) => {
        if (!item.examStatus) {
          ret.push({
            key: `ib_test_array[${index}].examStatus`,
            name: `Is this exam completed or planned? (${index + 1})`,
            page: `/application/ib-subject-test?check=1&index=${index + 1}#examStatus_${index + 1}`,
          });
        }
        if (item?.examStatus === 'Completed') {
          if (!item?.isReceivedScore) {
            ret.push({
              key: `ib_test_array[${index}].isReceivedScore`,
              name: `Have you received your score yet? (${index + 1})`,
              page: `/application/ib-subject-test?check=1&index=${index + 1}#isReceivedScore_${index + 1}`,
            });
          }
        }

        if (!item?.subject) {
          ret.push({
            key: `ib_test_array[${index}].subject`,
            name: `Subject (${index + 1})`,
            page: `/application/ib-subject-test?check=1&index=${index + 1}`,
          });
        }
        if (!item?.level) {
          ret.push({
            key: `ib_test_array[${index}].level`,
            name: `Level (select the one that applies) (${index + 1})`,
            page: `/application/ib-subject-test?check=1&index=${index + 1}`,
          });
        }

        if (ibSubjectHaveLanguageQuestion.includes(item?.subject)) {
          if (!item?.language) {
            ret.push({
              key: `ib_test_array[${index}].language`,
              name: `Language (select the one that applies) (${index + 1})`,
              page: `/application/ib-subject-test?check=1&index=${index + 1}`,
            });
          }
        }

        if (!item?.ibExamName) {
          ret.push({
            key: `ib_test_array[${index}].ibExamName`,
            name: `IB exam name (${index + 1})`,
            page: `/application/ib-subject-test?check=1&index=${index + 1}`,
          });
        }

        if (item?.ibExamName === 'Other') {
          if (!item?.ibExamSubjectNameDescribeOther) {
            ret.push({
              key: `ib_test_array[${index}].ibExamSubjectNameDescribeOther`,
              name: `Describe other (${index + 1})`,
              page: `/application/ib-subject-test?check=1&index=${index + 1}#ibExamSubjectNameDescribeOther_${index + 1}`,
            });
          }
        }

        if (!item?.dateTaken) {
          ret.push({
            key: `ib_test_array[${index}].dateTaken`,
            name: `Date taken of planned (${index + 1})`,
            page: `/application/ib-subject-test?check=1&index=${index + 1}#dateTaken_${index + 1}`,
          });
        }

        if (formatBoolean(item?.isReceivedScore) === true) {
          if (!item?.score) {
            ret.push({
              key: `ib_test_array[${index}].score`,
              name: `Score (${index + 1})`,
              page: `/application/ib-subject-test?check=1&index=${index + 1}#score_${index + 1}`,
            });
          }
        }
        if (formatBoolean(item?.isReceivedScore) === false) {
          if (item?.score!=='Score Not Yet Received') {
            ret.push({
              key: `ib_test_array[${index}].score`,
              name: `Score (${index + 1})`,
              page: `/application/ib-subject-test?check=1&index=${index + 1}#score_${index + 1}`,
            });
          }
        }
      });
    }

    return ret;
  }

  const checkAPSubjectTestCondition = (data:any) => {
    let ret: RequiredField[]  = [];
    if (data?.ap_test_array && data?.ap_test_array.length>0) {
      data?.ap_test_array.forEach((item: any, index: number) => {
        if (!item.subjectCM) {
          ret.push({
            key: `ap_test_array[${index}].subjectCM`,
            name: `AP exam (${index + 1})`,
            page: `/application/ap-subject-test?check=1&index=${index + 1}#subjectCM_${index + 1}`,
          });          
        }
        if (!item.examStatus) {
          ret.push({
            key: `ap_test_array[${index}].examStatus`,
            name: `Is this exam completed or planned? (${index + 1})`,
            page: `/application/ap-subject-test?check=1&index=${index + 1}`,
          });
        }

        if (item.examStatus === 'Completed') {
          if (!item.dateTaken) {
            ret.push({
              key: `ap_test_array[${index}].dateTaken`,
              name: `When did you take this test? (${index + 1})`,
              page: `/application/ap-subject-test?check=1&index=${index + 1}`,
            });
          }
          if (!item.isReceivedScore) {
            ret.push({
              key: `ap_test_array[${index}].isReceivedScore`,
              name: `Have you received your score yet? (${index + 1})`,
              page: `/application/ap-subject-test?check=1&index=${index + 1}#isReceivedScore_${index + 1}`,
            });
          }

          if (formatBoolean(item.isReceivedScore) === true) {
            if (!item.score) {
              ret.push({
                key: `ap_test_array[${index}].score`,
                name: `Score (${index + 1})`,
                page: `/application/ap-subject-test?check=1&index=${index + 1}`,
              });
            }
          }
        }
        else {
          if (!item.planToTakeExam) {
            ret.push({
              key: `ap_test_array[${index}].planToTakeExam`,
              name: `When do you plan to take the exam? (${index + 1})`,
              page: `/application/ap-subject-test?check=1&index=${index + 1}`,
            });
          }
        }
      });
    }
    return ret;
  }

  const checkRequiredFields = (data:any) =>{
    let result: RequiredField[]  = [];
    try {
      switch(page) {
        case 'sat-test':
          result = checkSatTestCondition(data);
          break;

        case 'act-test':
          result = checkActTestCondition(data);
          break;

        case 'ib-subject-test':
          result = checkIbSubjectCondition(data);
          break;

        case 'ap-subject-test':
        case 'act-subject-test': // legacy page key
          result = checkAPSubjectTestCondition(data);
          break;
      }
    }
    catch(ex){
      console.log('Error:', ex);
    }

    setFieldsFail(result);
  }

  useEffect(() => {
    checkRequiredFields(data);
  }, [data]);


  const handleClick = (field: any) => {
    history.push(field.page);
    onClose();
  };

  return (
    <Modal show={show} onHide={() => onClose()}>
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        {data && fieldsFail.length > 0 ? (
          <div>
            <h3>These fields are not yet valid, please complete them: </h3>
            <ul style={{ fontSize: '1rem', color: 'red' }}>
              {fieldsFail.map((field, index) => (
                <li key={index} onClick={() => handleClick(field)} style={{ cursor: 'pointer' }}>
                  {field.name}
                </li>
              ))}
            </ul>
          </div>
        ) : (
          <div>
            <h3>All required fields are filled</h3>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={() => onClose()}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}